import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import { getDatabase, ref, onValue} from "firebase/database";

class Payment extends Component {
  
  constructor() {
    super()

    if (localStorage.getItem('sessionId') === null) {
      window.location.reload(false);
    }

    this.state = {
      shoppingcarts: [],
      redirect: ''
    }

    

    const openAppRoute = (redirectUrl) => {
      localStorage.setItem('sessionId', this.props.match.params.id);
      this.unmountScript();
      this.setState({
        redirect: redirectUrl
      });
    };

    window.openAppRoute = openAppRoute;
    this._isMounted = false;

     
  }

  

  startListenerShoppingcart(reference_id)
  {
    const db = getDatabase();
    const starCountRef = ref(db, 'shoppingcart/'+ reference_id);

    let listen = onValue(starCountRef, (snapshot) => {
      if (snapshot.exists()) {

        if(this._isMounted)
        {
          this.setState({
            shoppingcarts: snapshot.val().shoppingcarts
          });

          const scriptLoader = document.createElement("script");
          scriptLoader.src = process.env.REACT_APP_API_URL +'/payment/wa/jscript/'+ reference_id;
          scriptLoader.async = false;
          scriptLoader.setAttribute("id",'scriptLoader');
          document.body.appendChild(scriptLoader);


          
        }

        
      }
      else {
        listen();
      }

        

    });

  }

  stopListenerShoppingcart(reference_id)
  {
    const db = getDatabase();
    const starCountRef = ref(db, 'shoppingcart/'+ reference_id);
    let listen = onValue(starCountRef, (snapshot) => {
    });
    listen();
  }

  

  fetchApi() {
      const requestOptions = {
        method: 'POST',
        body: JSON.stringify({ sessionId: this.props.match.params.id })
      };
      fetch(process.env.REACT_APP_API_URL+'/shoppingcart', requestOptions)
      .then(response => response.json())
      .then((json) => {

        
        this.stopListenerShoppingcart(this.props.match.params.id);
        this.startListenerShoppingcart(this.props.match.params.id);
        


      }).catch((e) => {

      });
      
      
  }

  

  unmountScript()
  {
    
    try
    {
      document.getElementById("scriptLoader").remove();
    }
    catch(error)
    {

    }

  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchApi();
    document.getElementById("root").scrollIntoView();

  }

  componentDidUpdate(){
   document.getElementById("root").scrollIntoView();
  }

  componentWillUnmount()
  {
    this._isMounted = false;
    this.stopListenerShoppingcart(this.props.match.params.id);
    this.unmountScript();
  }

  render(){


  const cssStyles = `
    .btn-theme{
      background-color: #24bf63;
      border-color:#24bf63;
      color:#FFFFFF;
  
      display: inline-block;
      vertical-align: middle;
      -webkit-transform: perspective(1px) translateZ(0);
      transform: perspective(1px) translateZ(0);
      box-shadow: 0 0 1px rgba(0, 0, 0, 0);
      overflow: hidden;
      -webkit-transition-duration: 0.3s;
      transition-duration: 0.3s;
      -webkit-transition-property: color, background-color, border-color;
      transition-property: color, background-color, border-color;
    }
    .btn-theme:hover{
      background-color: #24bf63;
      border-color:#24bf63;
      color:#FFFFFF;
    }

    .btn-theme:focus{
      background-color:#24bf63;
      border-color:#24bf63;
      color:#FFFFFF;
    }

    .btn-theme:active{
      background-color:#24bf63;
      border-color:#24bf63;
      color:#FFFFFF;
    }

    .btn-theme:not(:disabled):not(.disabled):active{
      color: #FFFFFF;
      background: #24bf63;
      border-color: #24bf63;
      outline: 0 none;
    }

    .btn-theme:not(:disabled):not(.disabled):focus{
      box-shadow: 0 0 5px #24bf63;
    }

    .btn-theme[disabled] {
      background: #24bf63 !important;
      border-color:#24bf63 !important;
    }

    .btn-theme[disabled]:hover {
      background: #24bf63 !important;
      border-color:#24bf63 !important;
    }
    `;

  if(this.state.redirect!==""){
    let redirectUrl = this.state.redirect;
    return <Redirect to={redirectUrl} />
  }

 
  if(this.state.shoppingcarts.length===0)
  {
      return (
          <div style={{ backgroundColor:"#FFFFFF", top:"0", bottom:"0", left:"0", right:"0", margin:"0px", position:"absolute", height:"100%"}}>
            <div style={{ backgroundColor:"#FFFFFF", top:"50%", left:"50%", marginTop:"-50px", marginLeft:"-50px", position:"absolute"}}>
              <div className="loader mt-0 mb-4" style={{ color: "#c53c46"}} />
              <div className="text-theme text-center"><h5>Loading...</h5></div>
            </div>
          </div>
        )
  }

  if(this.state.shoppingcarts[0].id===undefined)
  {

    return (
        <div>
          <div style={{ height: "50px" }}></div>
          <center>
            Payment link not found
            <div className="mt-4"></div>
          </center>

        </div>

      )
  }

  return (
    <section id="booking" style={{ backgroundColor: "#ffffff" }}>
    

      {this.state.shoppingcarts.map((shoppingcart,shoppingcart_index) => {
        
        

        let discountBox = ('')
        if(parseInt(shoppingcart.discount)>0) {
          discountBox = (
            <div className="row mb-2">
              <div className="col-8">
                <span style={{ fontSize: "16px" }}>Discount</span>
              </div>
              <div className="col-4 text-right">
                <span style={{ fontSize: "16px" }}>{shoppingcart.discount}</span>
              </div>
            </div>
          )
        }

        let dueOnArrivalBox = ('')
        if(parseInt(shoppingcart.due_on_arrival)>0) {
          dueOnArrivalBox = (
            <div className="card-body pt-0 pb-0">
              <hr className="mt-4" /> 
              <div className="row mb-2 mt-0">
                <div className="col-8">
                  <b style={{ fontSize: "16px" }}>Due now ({ shoppingcart.currency })</b>
                </div>
                <div className="col-4 text-right">
                  <b style={{ fontSize: "16px" }}>{ shoppingcart.due_now }</b>
                </div>
              </div>
              <div className="row mb-4 mt-0">
                <div className="col-8">
                  <span style={{ fontSize: "16px" }}>Due on arrival  ({ shoppingcart.currency })</span>
                </div>
                <div className="col-4 text-right">
                  <span style={{ fontSize: "16px" }}>{ shoppingcart.due_on_arrival }</span>
                </div>
              </div>
              
            </div>
          )
        }

      

      return (
        <div className="container"  key={shoppingcart_index}>
          <style>{cssStyles}</style>
          <div className="row">
            <div className="col-lg-12 col-md-12 mx-auto" style={{ marginLeft: "0px", paddingLeft: "0px", marginRight: "0px", paddingRight: "0px", overflowX: "hidden"  }}>
              
                
                  
                    <div className="row mb-0 d-flex justify-content-center">  
                      <div className="col-lg-6 col-lg-auto mb-6">

                        <div className="card shadow p-0 border-light h-100 mb-0">
                          <div className="card-header bg-light text-white pb-1">
                            <h4><img src={localStorage.getItem('logo')} alt="VERTIKAL TRIP" height="45"  style={{ marginRight: '15px' }} /></h4>
                          </div>
                
                          <div id="productSummary" className="card-body">
                          
                          <div>
                          <b>Main contact</b>
                          <div className="mt-0">
                          {shoppingcart.mainQuestions.map((mainQuestion,mainQuestion_index) => {
                            
                            let fullName = '';

                            if(mainQuestion.question_id==="firstName") {
                                  fullName += mainQuestion.answer;
                            }
                            if(mainQuestion.question_id==="lastName") {
                                  fullName += " "+ mainQuestion.answer;
                            }
                           
                            return (
                              <span key={mainQuestion_index} style={{ fontSize: "12px" }}>{fullName}</span>
                              )


                          })}
                        </div>
                          {shoppingcart.mainQuestions.map((mainQuestion,mainQuestion_index) => {
                            
                           
                            let phoneNumber = '';
                            
                            if(mainQuestion.question_id==="phoneNumber") {
                                  phoneNumber = mainQuestion.answer;
                            }
                               
                          
                            return (
                              <div key={mainQuestion_index} style={{ fontSize: "12px" }}>{phoneNumber}</div>
                              )

                          })}
                          
                          </div>
                          <hr />

                          { shoppingcart.products.map((product,product_index) => {
                  
                            let imageBox = ('')
                            if(product.image!=="")
                            {
                              imageBox = (
                                <div style={{ width: "60px", height: "60px",  position: "relative", paddingTop: "4px" }}>
                                  <img src={product.image} alt={product.title} className="rounded" height="60"  />
                                </div>
                              )
                            }

                            return (
                              <div className="no-gutters" id={ "bookingId-"+ product.booking_id } key={product_index}>
                                <div className="row mb-2">
                                  <div className="col-8 pl-4">
                                    <b>{ product.title }</b>
                                  </div>
                                  <div className="col-4 text-right">
                                    <div dangerouslySetInnerHTML={ {__html: product.product_total} } />
                                  </div>
                                </div>
                                <div className="row mb-4">
                                  <div className="col-12 row">
                                    <div className="ml-4 mb-2">
                                      {imageBox}
                                    </div>
                                    <div className="col-8 product-detail pl-4">
                                      {product.date}
                                      <br />
                                      {product.rate}
                                      <br />
                                      <div dangerouslySetInnerHTML={ {__html: product.product_detail} } />
                                      
                                    </div>
                                  </div>
                                  
                                  <div className="ml-4 product-detail mr-4 mt-2" dangerouslySetInnerHTML={ {__html: product.note} } />
                                </div>


                                {(() => {
                                  if('pickups' in product) {
                                    if(product.pickups.length!==0) {
                                    const pickupsBox = [];
                                    product.pickups.forEach((pickup) => {
                                      pickupsBox.push(
                                        <div className="row mb-2">
                                          <div className="col-8">
                                            <strong style={{ fontSize: "12px" }}>{pickup.title}</strong>
                                            <br />
                                            <span style={{ fontSize: "12px" }}>{pickup.unit_price}</span>
                                          </div>
                                          <div className="col-4 text-right">
                                            <div dangerouslySetInnerHTML={ {__html: pickup.price} } />
                                          </div>
                                        </div>
                                      )
                                    })

                                    return (
                                      <div className="card mb-4">
                                        <div className="card-body">
                                          {pickupsBox}
                                        </div>
                                      </div>
                                    )
                                    }
                                  }
                                })()}
                                


                                {(() => {
                                  if('extras' in product)
                                  {
                                    if(product.extras.length!==0) {
                                    const extrasBox = [];
                                    product.extras.forEach((extra) => {

                                      extrasBox.push(
                                        <div className="row mb-2">
                                          <div className="col-8">
                                            <strong style={{ fontSize: "12px" }}>{extra.title}</strong>
                                            <br />
                                            <span style={{ fontSize: "12px" }}><div dangerouslySetInnerHTML={ {__html: extra.unit_price} } /></span>
                                          </div>
                                          <div className="col-4 text-right">
                                            <div dangerouslySetInnerHTML={ {__html: extra.price} } />
                                          </div>
                                        </div>
                                      )
                        
                                    })

                                    return (
                                      <div className="card mb-4">
                                        <div className="card-body">
                                          {extrasBox}
                                        </div>
                                      </div>
                                    )
                                  }
                                  }
                                })()}
                  
                              </div>
                            )
                  
                          })}
                          
                          </div>
                          <div className="card-body pt-0 mt-0">
                            <hr />
                            <div className="row mb-2">
                              <div className="col-8">
                                <span style={{ fontSize: "16px" }}>Items</span>
                              </div>
                              <div className="col-4 text-right">
                                <span style={{ fontSize: "16px" }}>{shoppingcart.subtotal}</span>
                              </div>
                            </div>
                            {discountBox}

                            <div className="row mb-2">
                              <div className="col-8">
                                <b style={{ fontSize: "16px" }}>Total ({shoppingcart.currency})</b>
                              </div>
                              <div className="col-4 text-right">
                                <b style={{ fontSize: "16px" }}>{shoppingcart.total}</b>
                              </div>
                            {dueOnArrivalBox}
                            </div>

                            


                            <div className="card-body" style={{ 
                              paddingLeft: "0px",
                              paddingRight: "0px", 
                              paddingTop: "0px", 
                              paddingBottom: "15px",
                              marginTop: "0px",
                            }}>
                            <div id="paymentContainer" />
                            <div id="alert-payment" />
                            <div id="notice" />
                            </div>


                            <center>
                    <img className="ml-2" src={localStorage.getItem('assets')+"/img/payment/stripe.png"} height="20" alt="Powered by Stripe" />
                
                </center>
                <div style={{ height: "50px" }}></div>
                          </div>
                        </div>

                      

                      </div>
            
                      

                    </div>
                  </div>
                
            </div>
             
          </div>  
      )
      })}
     
    </section>
  )
  }
}

export default Payment;